module.exports = __webpack_public_path__ + "static/media/money.f3f8b7f6.svg";